module.exports = __webpack_public_path__ + "static/media/1007238.3db17755.png";